import { motion } from 'motion/react';
import React from 'react';

const SPRING_TRANSITION = {
  type: 'spring',
  stiffness: 200,
  mass: 1,
  damping: 15,
} as const;

const TWEEN_TRANSITION = {
  type: 'tween',
  duration: 0.15,
} as const;

type SpringAnimationProps = {
  children: React.ReactNode;
  className?: string;
  direction: 'left' | 'right' | 'up' | 'down';
  type?: 'spring' | 'tween';
};

const SpringAnimation = ({
  children,
  className,
  direction,
  type = 'spring',
}: SpringAnimationProps) => {
  return (
    <motion.div
      className={className}
      initial={{
        opacity: 0,
        ...(direction === 'left' && { x: -50 }),
        ...(direction === 'right' && { x: 50 }),
        ...(direction === 'down' && { y: -50 }),
        ...(direction === 'up' && { y: 50 }),
      }}
      animate={{
        opacity: 1,
        ...((direction === 'left' || direction === 'right') && { x: 0 }),
        ...((direction === 'up' || direction === 'down') && { y: 0 }),
      }}
      exit={{
        opacity: 0,
        ...(direction === 'left' && { x: -50 }),
        ...(direction === 'right' && { x: 50 }),
        ...(direction === 'down' && { y: -50 }),
        ...(direction === 'up' && { y: 50 }),
      }}
      transition={type === 'spring' ? SPRING_TRANSITION : TWEEN_TRANSITION}
    >
      {children}
    </motion.div>
  );
};

export default SpringAnimation;
